import {Percent, Prose} from '@raison/types';
import React from 'react';
import {To} from 'react-router';

export interface DashboardCategoryPortion {
    categoryPercent: Percent;
    categoryColor: string;
    categoryName: Prose;
}

export interface DashboardCategory {
    categorySlug: string;
    CategoryLink: React.ComponentType<{to: To}>;
    CategoryPage: React.ComponentType;
    CategoryContextProvider: React.ComponentType<React.PropsWithChildren>;
    useCategoryPortion: () => DashboardCategoryPortion;
}

export interface DashboardCategoryComposite {
    BalancesConsumer: React.ComponentType<{
        children: (results: DashboardCategoryPortion[]) => React.JSX.Element;
    }>;

    categoriesLinks: React.JSX.Element[];

    categoriesRoutes: React.JSX.Element[];
}

export namespace DashboardCategory {
    export const createBalanceConsumer = (cs: DashboardCategory[]): DashboardCategoryComposite['BalancesConsumer'] => {
        return function DashboardBalancesConsumers(props) {
            return props.children(cs.map(m => m.useCategoryPortion()));
        };
    };

    export const useBalancesConsumer = (cs: DashboardCategory[]) => {
        return React.useMemo(() => createBalanceConsumer(cs), [cs]);
    };
}
